module.exports = __webpack_public_path__ + "static/img/quote_1.080f517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/quote_1.png
// module id = rFrE
// module chunks = 1